/**
 * Возвращает цвет медали по её типу (gold / silver / bronze),
 * либо нейтральный цвет по умолчанию.
 *
 * @param {string} medal - Тип медали: "gold" | "silver" | "bronze".
 * @returns {string} HEX-цвет.
 */
export const getMedalColor = (medal) => {
  if (medal === "gold") return "#f3b742"
  if (medal === "silver") return "#cfd6df"
  if (medal === "bronze") return "#d6843d"

  return "#d7d0c3"
}
